import React from 'react';
import { Hero } from './components/Hero';
import { PainMarquee } from './components/PainMarquee';
import { TrustStrip } from './components/TrustStrip';
import { Services } from './components/Services';
import { WhyUs } from './components/WhyUs';
import { LocalHosting } from './components/LocalHosting';
import { Process } from './components/Process';
import { BostonProof } from './components/BostonProof';
import { ContactCTA } from './components/ContactCTA';
export function App() {
  return <div className="flex flex-col w-full min-h-screen text-ink font-sans bg-surface-warm" data-id="element-0">
      {/* Header */}
      <header className="sticky top-0 z-20 backdrop-blur-md bg-surface-warm/90 border-b border-ink/10" data-id="element-1">
        <div className="w-full max-w-[1100px] mx-auto flex justify-between items-center gap-4 flex-wrap py-3 px-4" data-id="element-2">
          <a href="/" className="text-[1.6rem] font-extrabold text-brand-deep" data-id="element-3">
            Mayto
            <span className="bg-gradient-to-r from-brand-teal to-brand-mint bg-clip-text text-transparent" data-id="element-4">
              Mation
            </span>
          </a>
          <nav className="flex flex-wrap items-center gap-6" data-id="element-5">
            <a href="/services" className="text-ink hover:text-brand-teal transition-colors font-medium" data-id="element-6">
              Services
            </a>
            <a href="/hosting" className="text-ink hover:text-brand-teal transition-colors font-medium" data-id="element-7">
              Hosting
            </a>
            <a href="/process" className="text-ink hover:text-brand-teal transition-colors font-medium" data-id="element-8">
              Process
            </a>
            <a href="/about" className="text-ink hover:text-brand-teal transition-colors font-medium" data-id="element-9">
              About
            </a>
            <a href="/contact" className="text-white font-semibold rounded-xl px-5 py-2.5 bg-gradient-to-r from-brand-deep to-brand-teal transition-all duration-200 hover:-translate-y-0.5 hover:shadow-hero" data-id="element-10">
              Contact
            </a>
          </nav>
        </div>
      </header>

      {/* Main Content */}
      <main className="w-full max-w-[1100px] mx-auto flex-1 px-4" data-id="element-11">
        <Hero data-id="element-12" />
        <PainMarquee data-id="element-13" />
        <TrustStrip data-id="element-14" />
        <Services data-id="element-15" />
        <WhyUs data-id="element-16" />
        <LocalHosting data-id="element-17" />
        <Process data-id="element-18" />
        <BostonProof data-id="element-19" />
        <ContactCTA data-id="element-20" />
      </main>

      {/* Floating Contact Button */}
      <a href="/contact" className="fixed right-4 bottom-4 text-white rounded-full px-5 py-3 bg-gradient-to-r from-brand-deep to-brand-teal shadow-hero hover:-translate-y-0.5 transition-transform duration-200 font-semibold z-10" data-id="element-21">
        Contact
      </a>

      {/* Footer */}
      <footer className="w-full bg-white border-t border-surface-border mt-12" data-id="element-22">
        <div className="max-w-[1100px] mx-auto px-4 py-8" data-id="element-23">
          <div className="grid md:grid-cols-3 gap-8 mb-6" data-id="element-24">
            <div data-id="element-25">
              <h3 className="font-bold text-ink mb-3" data-id="element-26">MaytoMation</h3>
              <p className="text-sm text-ink-muted" data-id="element-27">
                Automation, custom software, and local hosting for businesses
                tired of manual work, outsourced shops, and unpredictable cloud
                bills.
              </p>
            </div>
            <div data-id="element-28">
              <h3 className="font-bold text-ink mb-3" data-id="element-29">Services</h3>
              <ul className="space-y-2 text-sm" data-id="element-30">
                <li data-id="element-31">
                  <a href="/services#automation" className="text-ink-muted hover:text-brand-teal transition-colors" data-id="element-32">
                    Automation & Workflows
                  </a>
                </li>
                <li data-id="element-33">
                  <a href="/services#software" className="text-ink-muted hover:text-brand-teal transition-colors" data-id="element-34">
                    Custom Software Development
                  </a>
                </li>
                <li data-id="element-35">
                  <a href="/services#hosting" className="text-ink-muted hover:text-brand-teal transition-colors" data-id="element-36">
                    Local Hosting Solutions
                  </a>
                </li>
              </ul>
            </div>
            <div data-id="element-37">
              <h3 className="font-bold text-ink mb-3" data-id="element-38">Contact</h3>
              <p className="text-sm text-ink-muted mb-2" data-id="element-39">East Boston, MA</p>
              <a href="mailto:hello@maytomation.com" className="text-sm text-brand-teal hover:underline" data-id="element-40">
                hello@maytomation.com
              </a>
            </div>
          </div>
          <div className="pt-6 border-t border-surface-border flex flex-wrap justify-between items-center gap-4 text-sm text-ink-muted" data-id="element-41">
            <p data-id="element-42">© 2026 MaytoMation · Practical software and hosting for SMBs</p>
            <div className="flex gap-4" data-id="element-43">
              <a href="/privacy" className="hover:text-brand-teal transition-colors" data-id="element-44">
                Privacy Policy
              </a>
              <a href="/terms" className="hover:text-brand-teal transition-colors" data-id="element-45">
                Terms
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>;
}